import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { DocumentData } from "@/common/types/document";
import usePrivateAxios from "@/common/api/usePrivateAxios";

export const useDocumentOptions: () => UseQueryResult<DocumentData[], unknown> = () => {
  const privateAxios = usePrivateAxios();
  return useQuery<{data: {data: DocumentData[]}}, unknown, DocumentData[]>({
    queryKey: ['documentOptions'],
    queryFn: () => privateAxios.get('/documents/list_options'),
    select: (data) => data?.data?.data
  })
}